import * as yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';
export const previousDocumentAddFormSchema = yup.object().shape({
  webId: yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!').required(messages.MANDATORY_FIELD),
  finalActDocumentName: yup.string().required(messages.MANDATORY_FIELD),
  classification: yup.string().required(messages.MANDATORY_FIELD),
  finalActFileNumber: yup.string().required(messages.MANDATORY_FIELD),
  finalDocumentAdmissionDate: yup.date().required(messages.MANDATORY_FIELD),
  solutionType: yup.string().required(messages.MANDATORY_FIELD),
  administrativeUnit: yup.string().required(messages.MANDATORY_FIELD),
  authority: yup.string().required(messages.MANDATORY_FIELD),
  executionAndEffectivenessDateMandatory: yup.boolean().notRequired(),
  executionDate: yup.date().when("executionAndEffectivenessDateMandatory", (keys, schema) =>
    keys[0] ? schema.required(messages.MANDATORY_FIELD) : schema.notRequired()
  ),
  effectivenessDate: yup.date().notRequired(),
});
